const saloons = {
  PreschoolAutism: 1,
  ElementalAutism: 2,
  ResourceRoom: 3,
  IndependentLife: 4,
  VocationalIndustrialArts: 5,
  CentralLevel: 6,
  Center: 7,
};

export default saloons;
